/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Room } from './Room';
import {
    RoomFromJSON,
    RoomFromJSONTyped,
    RoomToJSON,
    RoomToJSONTyped,
} from './Room';

/**
 * 
 * @export
 * @interface Level
 */
export interface Level {
    /**
     * 
     * @type {string}
     * @memberof Level
     */
    levelName: string;
    /**
     * 
     * @type {Array<Room>}
     * @memberof Level
     */
    rooms: Array<Room>;
}

/**
 * Check if a given object implements the Level interface.
 */
export function instanceOfLevel(value: object): value is Level {
    if (!('levelName' in value) || value['levelName'] === undefined) return false;
    if (!('rooms' in value) || value['rooms'] === undefined) return false;
    return true;
}

export function LevelFromJSON(json: any): Level {
    return LevelFromJSONTyped(json, false);
}

export function LevelFromJSONTyped(json: any, ignoreDiscriminator: boolean): Level {
    if (json == null) {
        return json;
    }
    return {
        
        'levelName': json['levelName'],
        'rooms': ((json['rooms'] as Array<any>).map(RoomFromJSON)),
    };
}

export function LevelToJSON(json: any): Level {
    return LevelToJSONTyped(json, false);
}

export function LevelToJSONTyped(value?: Level | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'levelName': value['levelName'],
        'rooms': ((value['rooms'] as Array<any>).map(RoomToJSON)),
    };
}

